<template>
  <div>
    <!--课程统计-->
    <div class="row">
      <div class="col-sm-2">
             <div class="v-card" style="max-height: 100px; max-width: 360px;">
                 <div class="v-list-item v-list-item--three-line theme--light">
                   <div class="v-list-item__content">
                         <div class="v-list-item__title" style="color: rgb(148, 148, 148);">
                            姓名
                         </div>
                         <div class="v-list-item__subtitle" style="color: rgb(52, 52, 52); font-size: 24px; font-weight: bold;">
                            {{pageData.studentName}}
                         </div>
                   </div>
                   <div class="v-avatar v-list-item__avatar" style="height: 40px; min-width: 40px; width: 40px;">
                          <div class="tip_new">
                            <!--响应式图片-->
                              <img src="@/assets/class.png" class="img-xys" >
                          </div>
                   </div>
                 </div>
             </div>
      </div>
       <div class="col-sm-2">
             <div class="v-card" style="max-height: 100px; max-width: 360px;">
                 <div class="v-list-item v-list-item--three-line theme--light">
                   <div class="v-list-item__content">
                         <div class="v-list-item__title" style="color: rgb(148, 148, 148);">
                            手机号
                         </div>
                         <div class="v-list-item__subtitle" style="color: rgb(52, 52, 52); font-size: 24px; font-weight: bold;">
                            {{pageData.studentTel}}
                         </div>
                   </div>
                   <div class="v-avatar v-list-item__avatar" style="height: 40px; min-width: 40px; width: 40px;">
                          <div class="tip_new1">
                             <!--响应式图片-->
                              <img src="@/assets/course.png" class="img-xys">
                          </div>
                   </div>
                 </div>
             </div>
      </div>
       <div class="col-sm-2">
             <div class="v-card" style="max-height: 100px; max-width: 360px;" >
                 <div class="v-list-item v-list-item--three-line theme--light">
                   <div class="v-list-item__content">
                         <div class="v-list-item__title" style="color: rgb(148, 148, 148);">
                            已培训课程
                         </div>
                         <div class="v-list-item__subtitle" style="color: rgb(52, 52, 52); font-size: 24px; font-weight: bold;">
                            {{pageData.trainCourseTotal}}
                         </div>
                   </div>
                   <div class="v-avatar v-list-item__avatar" style="height: 40px; min-width: 40px; width: 40px;">
                          <div class="tip_new2">
                             <!--响应式图片-->
                              <img src="@/assets/lesson.png" class="img-xys"  >
                          </div>
                   </div>
                 </div>
             </div>
      </div>

      <div class="col-sm-2">
             <div class="v-card" style="max-height: 100px; max-width:360px;">
                 <div class="v-list-item v-list-item--three-line theme--light">
                   <div class="v-list-item__content">
                         <div class="v-list-item__title" style="color: rgb(148, 148, 148);">
                            已培训章节
                         </div>
                         <div class="v-list-item__subtitle" style="color: rgb(52, 52, 52); font-size: 24px; font-weight: bold;">
                            {{pageData.trainLessonTotal}}
                         </div>
                   </div>
                   <div class="v-avatar v-list-item__avatar" style="height: 40px; min-width: 40px; width: 40px;">
                          <div class="tip_new3">
                             <!--响应式图片-->
                              <img src="@/assets/major.png" class="img-xys" >
                          </div>
                   </div>
                 </div>
             </div>
      </div>

    </div>
    <!--签到统计-->
    <div class="box1">
      <div class="course_today">
        <div class="course_title">
          今日课程
        </div>
        <div v-if="pageData.trainCourseNowList == ''">暂无今日课程</div>
        <div v-for="(item,index) in pageData.trainCourseNowList" :key="index" class="row_course">
          <div class="card">
            <div class="row_content">课程名：{{item.trainCourseName}}
              <div style="width: 70px; display:inline-block; margin-left:20px;cursor: pointer; position: relative;"
                @click="doCourseIntroduction(item.courseRemark)"
              >
                <img src="../../assets/icon_jianjie .png" alt="" style="position: absolute;left:-14px;top: 3px;"/>简介
              </div>
            </div>
            <div class="row_content">有效期：{{item.courseValidTime}}</div>
            <div class="row_content">培训课时：{{item.courseHours}}</div>
            <div class="row_content">学习进度：{{item.completeRate}}%</div>
            <div class="box5 row_content">
              <div v-if="signInFlg || !item.signInDisableFlg" class="button">签    到</div>
              <BBtnPrimary v-else class="pri-btn" :clicked="doSignIn" :hiddenKey="String(item.trainClassId)" btn-txt="签    到" />
              <BBtnPrimary class="pri-btn" :clicked="doKeepLearning" :hiddenKey="item" btn-txt="继续学习" />
              <BBtnPrimary class="pri-btn" :clicked="doDataView" :hiddenKey="item" btn-txt="资料查看" />
            </div>
          </div>
        </div>
      </div>

      <div class="course_today">
        <div class="course_title">
          已学课程
        </div>
        <div v-if="pageData.trainCourseOldList == ''">暂无已学课程</div>
        <div v-for="(item,index) in pageData.trainCourseOldList" :key="index" class="row_course">
          <div class="card">
            <div class="row_content">课程名：{{item.trainCourseName}}
              <div style="width: 70px; display:inline-block; margin-left:20px;cursor: pointer;position: relative;"
                @click="doCourseIntroduction(item.courseRemark)"
              >
                <img src="../../assets/icon_jianjie .png" alt="" style="position: absolute;left:-14px;top: 3px;">简介
              </div>
            </div>
            <div class="row_content">有效期：{{item.courseValidTime}}</div>
            <div class="row_content">培训课时：{{item.courseHours}}</div>
            <div class="row_content">学习进度：{{item.completeRate}}%</div>
            <div class="box5 row_content">
              <BBtnPrimary class="pri-btn" v-if="item.completeFlg == '1'" :clicked="doGraduationProve" :hiddenKey="String(item.trainClassId)" btn-txt="结业证明" />
              <BBtnPrimary class="pri-btn" :clicked="doKeepLearning" :hiddenKey="item" btn-txt="继续学习" />
              <BBtnPrimary class="pri-btn" :clicked="doDataView" :hiddenKey="item" btn-txt="资料查看" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BBtnPrimary from "../../components2/BBtnPrimary";
import {init,doSignIn} from "@/api/stuDashboard";
import BPopupCancel from "../../components2/BPopupCancel";
import Hub from "../../events/Hub";
import Vue from "vue";
export default {
  name: "CourseManagement",
  components: {
    BBtnPrimary
  },
  data: () => ({
    totalPages: 0,
    page: 1,
    limit: 10,
    totalCount: 0,
    navi: [{ name: "stu-dashboard" }],
    pageData: {},
    courseInfoFlg: false,
    courseRemark: "",
    signInFlg: false,
  }),
  beforeMount() {
    this.$store.commit('SET_NAVI_DATA', this.navi);
  },
  created() {
  },
  // 页面载入之前
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // vm.doSearch(true);
      vm.init()
    });
  },
  mounted() {
    
  },
  methods: {
    async init () {
      const data = await init();
      this.pageData = data.data
    },
    // 继续学习
    doKeepLearning (item){
      this.$router.push({
        name: "stu-lesson-management",
        params: {
          courseId: item.trainCourseId,
          classId: item.trainClassId
        },
      });
    },
    // 资料查看
    doDataView (item){
      this.$router.push({
        name: "stu-file-management",
        params: {
          courseId: item.trainCourseId,
          classId: item.trainClassId
        },
      });
    },
    // 签到
    async doSignIn (trainClassId){
      console.log("doSignIn")
      this.signInFlg = true

      var param = {
        classId: trainClassId,
      };
      const data = await doSignIn(param);
      Vue.prototype.$vsnackbar.show(data.msg);
    },
    // 结业证明
    doGraduationProve (trainClassId){
      this.$router.push({
        name: "stu-graduation-prove",
        params: {
          classId: trainClassId,
        },
      });
    },
    // 课程简介
    doCourseIntroduction (courseRemark){
      this.data = {
        courseRemark: courseRemark,
      };
      Hub.$emit("open-modal3");
      Hub.$emit("set-modal-data3", this.data, "课程简介", BPopupCancel);
    },
    upConfirm () {
      this.courseInfoFlg = false
    },
    destroyed() {
      Hub.$off("modal-confirm", this.set);
    },

  }
    
};
</script>

<style scoped>
.v-list-item__avatar {
    -ms-flex-item-align: start;
    align-self: flex-start;
    margin-top: 16px;
    margin-bottom: 16px;
}
.v-avatar {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border-radius: 50%;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    line-height: normal;
    position: relative;
    text-align: center;
    vertical-align: middle;
    overflow: hidden;
}
.v-list-item__subtitle {
    margin-left: 20px;
    white-space: normal;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    display: -webkit-box;
}
.v-list-item__title {
    -ms-flex-item-align: center;
    align-self: center;
    /* font-size: .929rem; */
}
.v-list-item__subtitle, .v-list-item__title {
    -webkit-box-flex: 1;
    -ms-flex: 1 1 100%;
    flex: 1 1 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.v-list-item__content {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-item-align: center;
    align-self: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-flex: 1;
    -ms-flex: 1 1;
    flex: 1 1;
    overflow: hidden;
    padding: 12px 0;
}
.v-list-item {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 100%;
    flex: 1 1 100%;
    letter-spacing: normal;
    min-height: 48px;
    outline: none;
    padding: 0 16px;
    position: relative;
    text-decoration: none;
}

.v-list-item--three-line {
    min-height: 88px;
}
.v-card {
    border: 1px solid #D0D0D0;
    border-width: thin;
    display: block;
    max-width: 100%;
    outline: none;
    text-decoration: none;
    -webkit-transition-property: opacity,-webkit-box-shadow;
    transition-property: opacity,-webkit-box-shadow;
    transition-property: box-shadow,opacity;
    transition-property: box-shadow,opacity,-webkit-box-shadow;
    overflow-wrap: break-word;
    position: relative;
    white-space: normal;
}

.v-card--link {
    cursor: pointer;
}

.col-sm-2 {
  display: block;
  float: left;
  width: 20%;
  height: 90px;
  margin-left:28px;
  margin-right: 40px;
}

.col-12 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
}

.row{
     display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-around;
    height: 90%;
    margin-top: 10px;
    margin-bottom: 10px;
}

.img-xys{
  display: inline-block;
  height: auto;
  max-width: 100%;
}
hr{
   border: 1px solid #EEE;
   float: left; 
   width: 99%;
}

.box_new {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-around;
    height: 90%;
    margin-top: 10px;
    margin-bottom: 10px;
}

.item_new {
    border: 1px solid #D0D0D0;
    width: 15%;
    height: 90px;
    margin-left:28px;
    margin-right: 40px;
}

.tip_new{
  display: block;
  float: left;
  width: 30px;
  height: 30px;
  -webkit-border-radius:50px;
  -moz-border-radius:50px;
  -o-border-radius:50px;
  border-radius:50px;
}
.tip_new1{
  display: block;
  float: left;
  width: 30px;
  height: 30px;
  -webkit-border-radius:50px;
  -moz-border-radius:50px;
  -o-border-radius:50px;
  border-radius:50px;
}
.tip_new2{
  display: block;
  float: left;
  width: 30px;
  height: 30px;
  -webkit-border-radius:50px;
  -moz-border-radius:50px;
  -o-border-radius:50px;
  border-radius:50px;
}

.tip_new3{
  display: block;
  float: left;
  width: 30px;
  height: 30px;
  -webkit-border-radius:50px;
  -moz-border-radius:50px;
  -o-border-radius:50px;
  border-radius:50px;
}

.tip_new4{
  display: block;
  float: left;
  width: 30px;
  height: 30px;
  -webkit-border-radius:50px;
  -moz-border-radius:50px;
  -o-border-radius:50px;
  border-radius:50px;
}


.course_item_new{
    width: 95%;
    height: 320px;
    margin-left: 10px;
    margin-bottom: 0px;
    padding: 0px;
}

.course_title_new{
  display: inline;
  height: 80px;
}

.course_title_span_new{
  display: block;
  font-size: 16px;
  font-weight: bold;
  padding-top: 10px;
  padding-bottom: 10px;
}

.major_count{
  font-size: 30px;
  color: #7EC0EE;
}

.course_count{
  font-size: 30px;
  color: #FF9F7F;
}

.lesson_count{
  font-size: 30px;
  color: #FFD700;
}

.class_count{
  font-size: 30px;
  color: #C0FF3E;
}

.student_count{
  font-size: 30px;
  color: #E066FF;
}

.course_img_new{
  width: 100%;
  height: 200px;
  padding: 0px;
  margin-bottom: 0px;
}

.box1 {
    display: flex;
    flex-wrap: wrap;
    height: 90%;
    margin-top: 30px;
    margin-bottom: 10px;
}

.box1_top_course {
    display: flex;
    flex-wrap: wrap;
    height: 90%;
    margin-top: 10px;
    margin-bottom: 10px;
}
.top_course_item_param {
    display: inline;
    width: 95%;
    height: 50px;
    margin-left:40px;
}

.sign_item_param {
    display: inline;
    width: 95%;
    height: 140px;
    margin-left:40px;
}

.sign_date{
  width: 460px;
  height: 60px;
  float: right;
  margin-right:20px;
  padding-left: 0px;
}

.sign_item {
    border: 1px solid #F0F0F0;
    display: inline;
    width: 95%;
    height: 500px;
    margin-left: 40px;
}

.sign_title{
  display: inline;
  height: 80px;
}

.top_course_title{
  display: inline;
  height: 80px;
}

.sign_search_param{
  display: flex;
  align-items: right;
  height: 100px;
  width: 600px;
  padding-top: 10px;
  float: right;
}

.sign_label_1{
  display: block;
  height: 40px;
  width: 200px;
  float: right;
  margin-top: 15px;
}

.sign_label{
  display: flex;
  /*width: 110px;*/
  height: 38px;
  background:#0169a6;
  color: #FEFEFE;
  justify-content: center;
  align-items: center;
  margin: 0 0.5em 0 0;
  cursor: pointer;
  font-size: 14px;
  padding: 10 1em;
}

.sign_title span{
  display: block;
  font-size: 16px;
  font-weight: bold;
  padding-top: 10px;
  padding-bottom: 10px;
}

.teacher_title{
  display: inline;
  height: 80px;
}

.teacher_title_span{
  display: block;
  font-size: 16px;
  font-weight: bold;
  padding-top: 10px;
  padding-bottom: 10px;
}

.teacher_img{
  width: 100%;
  height: 270px;
  padding: 0px;
  margin-bottom: 0px;
}

.course_title_span{
  display: block;
  font-size: 16px;
  font-weight: bold;
  padding-top: 10px;
  padding-bottom: 10px;
}

.course_img{
  width: 100%;
  height: 270px;
  padding: 0px;
  margin-bottom: 0px;
}

.box2 {
    background-color: #F0F0F0;
    display: flex;
    flex-wrap: wrap;
    height: 100%;
    margin-top: 10px;
    margin-bottom: 10px;
}

.top_course_item {
    border: 1px solid #F0F0F0;
    display: inline;
    width: 95%;
    height: 500px;
    margin-left: 40px;
    padding: 0px;
}


.top_course_span{
  display: block;
  font-size: 16px;
  font-weight: bold;
  padding-top: 10px;
  padding-bottom: 10px;
}

.course_today {
  width: 100%;
  height: auto;
  margin-left: 50px;
}

.course_title {
  font-size: 17px;
  font-weight: bold;
  margin-left: -20px;
  margin-bottom: 10px;
  margin-top: 10px;
}

.box5 {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 5px;
}

.row_course {
  display: flex;
  flex-direction: row;
  height: auto;
  margin-bottom: 20px;
}

.card {
  width: 710px;
  height: 160px;
  border: 1px solid #D0D0D0;
  border-width: thin;
  margin-left: -20px;
}

.row_content {
  margin-top: 5px;
  margin-bottom: 5px;
  margin-left: 5px;
}

.pri-btn {
  margin-right: 15px;
}
.button {
    display: flex;
    height: 38px;
    background: gray;
    border-radius: 5px;
    color: #FEFEFE;
    justify-content: center;
    align-items: center;
    margin: 0 1.5em 0 0;
    cursor: pointer;
    font-size: 14px;
    padding: 0 1em;
}
</style>
